import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'
import favicon from '../images/favicon-32x32.png';

import '../assets/scss/main.scss'

const Layout = ({ children, location }) => {

  let content;

  if (location && location.pathname === '/') {
    content = (
      <div>
        <Helmet>
          <link rel="icon" href={favicon} />
        </Helmet>
        {children}
      </div>
    )
  } else {
    content = (
      <div id="wrapper" className="page">
        <Helmet>
          <link rel="icon" href={favicon} />
        </Helmet>
        <div>
          {children}
        </div>
      </div>
    )
  }

  return (
    <StaticQuery
      query={graphql`
        query SiteTitleQuery {
          site {
            siteMetadata {
              title
            }
          }
        }
      `}
      render={data => (
        <>
          <Helmet
            title={data.site.siteMetadata.title}
            meta={[
              { name: 'description', content: 'Sample' },
              { name: 'keywords', content: 'sample, something' },
            ]}
          >
            <html lang="en" />
          </Helmet>
          {content}
        </>
      )}
    />

  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
